module.exports = __webpack_public_path__ + "img/1550150427.b8c43adf.jpg";